import { defaultFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const datasetPageConfig = {
  namespacesRequired: ['dataset', 'tables'],
  layout: {
    filterBar: defaultFilterBarConfig,
    noPaddedContent: true,
  },
} satisfies LayoutPageConfig;
